import { DelimitedArrayParam, withDefault } from 'use-query-params';

// istanbul ignore next
function createMultiArrayParam(defaultStatus: string[] | undefined) {
  return withDefault(DelimitedArrayParam, defaultStatus);
}

export default createMultiArrayParam;
